import Axios from "axios";
import _ from "lodash";
import React, { useMemo, useState } from "react";
import AddTeacherModal from "./AddTeacherModal/AddTeacherModal";
import AdminTeacherCard from "./AdminTeacherCard/AdminTeacherCard";
import AdminTeacherModal from "./AdminTeacherModal/AdminTeacherModal";
import ViewTimesheet from "./CreateTimesheet/ViewTimesheet/ViewTimesheet";
import NewLoadingScreen from "./NewLoadingScreen/NewLoadingScreen";
import SearchHeader from "./SearchHeader/SearchHeader";
import { FilterTypeId } from "./SearchHeader/filters-type";
import { baseUrl } from "./assets/Animations";
import loadingping from "./img/loadingpin.svg";
import { getRequestHeaders } from "./api";

const AdminDashboard = (props) => {
  const [teachers, setTeachers] = useState([]);
  const [filteredTeachers, setFilteredTeachers] = useState([]);
  const [teachersToDisplay, setTeachersToDisplay] = useState([]);
  const [teacherModal, setTeacherModal] = useState(false);
  const [wholeAvail, setWholeAvail] = useState([]);
  const [allStudents, setAllStudents] = useState([]);
  const [nameQuery, setNameQuery] = useState("");
  // const [instQuery, setInstQuery] = useState("");
  // const [schoolQuery, setSchoolQuery] = useState("");
  // const [statusQuery, setStatusQuery] = useState("");
  // const [dateQuery, setDateQuery] = useState("Everyday");
  // const [fullQuery, setFullQuery] = useState("Available");
  const [filterState, setFilterState] = useState({});
  //   const [background, setBackground] = useState("background-1.jpg");
  const [addTeacherModal, setAddTeacherModal] = useState(false);
  const [lineView, setLineView] = useState(false);
  const [studentModal, setStudentModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingSVG, setLoadingSVG] = useState(false);
  const [openTimesheet, setOpenTimesheet] = useState(false);
  const [timesheets, setTimesheets] = useState([]);
  const [schools, setSchools] = useState([]);

  const isManager = props.userData.PermissionLevel === "manager" && props.userData.IsAdmin;

  React.useEffect(() => {
    setLoadingSVG(true);
    getTeachersAndStudents();
    getTimesheets();
    getSchoolFilterOptions()
  }, []);

  React.useEffect(() => {
    filterTeachers();
  }, [teachers]);

  React.useEffect(() => {
    if (teacherModal && !props.studentModal2022) {
      setTimeout(() => {
        props.getNotesAboutModal(
          teacherModal.TeacherID,
          "teacherId",
          teacherModal.Name
        );
      }, 300);
    }
  }, [teacherModal, props.studentModal2022]);

  React.useEffect(() => {
    calculateAndSortByNumberOfStudents();
    if (teacherModal && teacherModal.TeacherID) {
      updateOpenTeacherModal();
    }
  }, [allStudents, filteredTeachers]);

  React.useEffect(() => {
    filterTeachers();
    changeBackgroundImageBySchool();
  }, [nameQuery, filterState]);

  const getTeachersAndStudents = () => {
    Axios.get(`${baseUrl}/school-management`, getRequestHeaders())
      .then((studentResponse) => {
        getTeachers(studentResponse.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getTimesheets = () => {
    Axios.get(`${baseUrl}/getalltimesheetsendpoint`)
      .then((response) => {
        setTimesheets(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getTeachers = (theStudents) => {
    Axios.get(`${baseUrl}/initialadminrequest`, getRequestHeaders())
      .then((response) => {
        createTheNewStudentListInEachTeacherAndSetTeachers(response.data);
        setAllStudents(theStudents);
        setLoadingSVG(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const createTheNewStudentListInEachTeacherAndSetTeachers = (list) => {
    for (let i = 0; i < list.length; i++) {
      list[i].newStudentList = [];
    }
    setTeachers(list);
  };

  const changeBackgroundImageBySchool = () => {
    // if (schoolQuery === "mma") {
    //   setBackground("MMA.jpg");
    // } else if (schoolQuery === "lsma") {
    //   setBackground("LMA.jpg");
    // } else if (schoolQuery === "tma") {
    //   setBackground("TMA.jpg");
    // } else if (schoolQuery === "glma") {
    //   setBackground("GLMA.jpg");
    // } else {
    //   setBackground("background-1.jpg");
    // }
  };

  const calculateAndSortByNumberOfStudents = () => {
    //ADD NEW CATAGORY TO THE TEACHERS
    let teachersWithStudents = filteredTeachers;
    for (let i = 0; i < teachersWithStudents.length; i++) {
      teachersWithStudents[i].newStudentList = [];
    }
    //CHECK ALL STUDENTS TO SEE WHO THEIR TEACHER IS
    for (let i = 0; i < allStudents.length; i++) {
      if (allStudents[i].familyStatus === "Active") {
        for (let j = 0; j < allStudents[i].students.length; j++) {
          if (allStudents[i].students[j].studentStatus === "Active") {
            let teachersId = allStudents[i].students[j].teachersId;
            for (let k = 0; k < teachersWithStudents.length; k++) {
              if (teachersWithStudents[k].TeacherID === teachersId) {
                teachersWithStudents[k].newStudentList.push({
                  familyId: allStudents[i].familyId,
                  studentId: allStudents[i].students[j].studentId,
                  firstName: allStudents[i].students[j].studentName,
                  lastName: allStudents[i].familyName,
                  address: allStudents[i].address,
                  students: allStudents[i].students,
                });
              }
            }
          }
        }
      }
    }
    setTeachersToDisplay([...sortByStudent(teachersWithStudents)]);
  };

  const sortByStudent = (list) => {
    let sortedFinalList = list.sort((a, b) => {
      return b.newStudentList.length - a.newStudentList.length;
    });
    return sortedFinalList;
  };

  const filterTeachers = () => {
    const masterList = teachers.filter((teacher) => {
      // Name
      const teachName = (teacher.Name ?? "").toString().toLocaleLowerCase();
      const nameFilter = (nameQuery ?? "").toString().toLocaleLowerCase();
      const nameMatch = !nameFilter || teachName.includes(nameFilter);
      // Schools
      const selectedSchools = isManager ? [props.userData.School] : filterState.school;
      const schoolMatch =
        !selectedSchools ||
        selectedSchools.length === 0 ||
        selectedSchools.includes(teacher.School);
      // Instruments
      const selectedInstruments = filterState.instrument;
      const instrumentMatch =
        !selectedInstruments ||
        selectedInstruments.length === 0 ||
        teacher.InstrumentList.some((instrument) =>
          selectedInstruments.includes(instrument.id)
        );
      // Days
      const selectedDays = filterState.days;
      const dayMatch = !selectedDays || selectedDays.length === 0 || 
        ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].some(day => 
          teacher.AvailabilityDetails[day]?.length > 0 && selectedDays.includes(day) && teacher.WantsMoreStudents && teacher.Status !== "goon" && teacher.Status !== "summer-break" && teacher.Status !== "leaving" && teacher.Status !== "Left School"
        );

        //FILTER OUT TEACHER MARKED AS FULL / PROBATION / LEAVING / SUMMER BREAK
      const availableMatch =
        !filterState.available || teacher.WantsMoreStudents && teacher.Status !== "goon" && teacher.Status !== "summer-break" && teacher.Status !== "leaving" && teacher.Status !== "Left School";

      const hideLeftSchool =
        filterState.leftSchool || teacher.Status !== "Left School";
      return nameMatch && instrumentMatch && availableMatch && schoolMatch && hideLeftSchool && dayMatch;
    });

    setFilteredTeachers(masterList);
  };

  const openNewTeacher = () => {
    setAddTeacherModal((prevState) => !prevState);
  };
  const closeNewTeacherModal = (teacherInfo) => {
    let addATeacher = teachers;
    addATeacher.push(teacherInfo);
    setTeachers([...addATeacher]);
    setAddTeacherModal(false);
  };

  const removeDeletedTeacher = (TeacherID) => {
    for (let i = 0; i < teachers.length; i++) {
      if (teachers[i].TeacherID === TeacherID) {
        teachers.splice(i, 1);
        setTeachers([...teachers]);
      }
    }
  };

  const massCheck = (isChecked) => {
    let theBoxes = document.getElementsByClassName("student-checkbox");
    if (isChecked) {
      for (let i = 0; i < theBoxes.length; i++) {
        theBoxes[i].checked = true;
      }
    } else {
      for (let i = 0; i < theBoxes.length; i++) {
        theBoxes[i].checked = false;
      }
    }
  };

  const copyAttempt = () => {
    let theList = "";
    let theBoxes = document.getElementsByClassName("student-checkbox");
    for (let i = 0; i < theBoxes.length; i++) {
      if (theBoxes[i].checked === true) {
        theList = theList + " " + theBoxes[i].value + ";";
      }
    }
    navigator.clipboard.writeText(theList);
    setTimeout(function () {
      alert("Emails have been copied to you clipboard");
    }, 0);
  };
  const openStudentModal = async (familyId) => {
    setLoading("Getting Student");
    Axios.get(`${baseUrl}/school-management/${familyId}`)
      .then((res) => {
        setStudentModal(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const updateOpenTeacherModal = () => {
    if (!teacherModal || !teacherModal.TeacherID) {
      return;
    }
    let updatedTeacherModal = teacherModal;
    for (let i = 0; i < teachers.length; i++) {
      if (teacherModal.TeacherID === teachers[i].TeacherID) {
        updatedTeacherModal.newStudentList = teachers[i].newStudentList;
        setTeacherModal(updatedTeacherModal);
      }
    }
  };
  const closeStudentModal = (msg, family) => {
    let updatedStudents = allStudents;
    for (let i = 0; i < updatedStudents.length; i++) {
      if (updatedStudents[i].familyId === family.familyId) {
        updatedStudents[i] = family;
      }
    }
    setAllStudents([...updatedStudents]);
    setStudentModal(false);
  };
  const closeTeacherModal = (teacherData) => {
    //setModal(false)
    setTeacherModal(false);
    //props.setShowNotes(false)
    props.closeSideNotesWithAnimation();
    let updatedTeacherList = teachers;
    let updatedFilteredTeacherList = filteredTeachers;
    for (let i = 0; i < updatedTeacherList.length; i++) {
      if (updatedTeacherList[i].TeacherID === teacherData.TeacherID) {
        updatedTeacherList[i] = teacherData;
        setTeachers([...updatedTeacherList]);
      }
    }
    for (let i = 0; i < updatedFilteredTeacherList.length; i++) {
      if (updatedFilteredTeacherList[i].TeacherID === teacherData.TeacherID) {
        updatedFilteredTeacherList[i] = teacherData;
        setFilteredTeachers([...updatedFilteredTeacherList]);
      }
    }
  };

  const getSchoolFilterOptions = async () => {
    let schoolOptions = [];
    Axios.get(`${baseUrl}/schools`)
    .then((res) => {
      res.data.forEach(school => {
        schoolOptions.push({ id: school.schoolAbbreviation.toLocaleLowerCase(), label: school.name.split(' ')[0] });
      })
    })
    .catch((err) => {
      console.log(err);
    })
    setSchools(schoolOptions);
  }

  const filters = useMemo(
    () => [
      {
        id: "available",
        label: "Available Only",
        type: FilterTypeId.Switch,
      },
      {
        id: "leftSchool",
        label: "Show Left School",
        type: FilterTypeId.Switch,
      },
      {
        id: "days",
        label: "Days",
        type: FilterTypeId.Dropdown,
        options: [
          { id: "Monday", label: "Mondays" },
          { id: "Tuesday", label: "Tuesdays" },
          { id: "Wednesday", label: "Wednesdays" },
          { id: "Thursday", label: "Thursdays" },
          { id: "Friday", label: "Fridays" },
          { id: "Saturday", label: "Saturdays" },
          { id: "Sunday", label: "Sundays" },
        ],
      },
      {
        id: "instrument",
        label: "Instrument",
        type: FilterTypeId.Dropdown,
        options:
          teachers &&
          _.uniqBy(
            teachers.reduce((acc, teacher) => {
              return [
                ...acc,
                ...teacher.InstrumentList.map((instrument) => {
                  return {
                    id: instrument.id,
                    label: instrument.name,
                    group: instrument.instrumentGroup,
                  };
                }),
              ];
            }, []),
            (x) => x.id
          ),
      },
      !isManager && {
        id: "school",
        label: "School",
        type: FilterTypeId.Dropdown,
        options: schools,
      },
    ],
    [teachers]
  );

  return (
    <div
    //   style={{
    //     backgroundImage:
    //       "linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(" +
    //       background +
    //       ")",
    //   }}
    >
      {loading && <NewLoadingScreen message={loading} />}
      {teacherModal && (
        <AdminTeacherModal
          openStudentModal={openStudentModal}
          closeModal={closeTeacherModal}
          wholeAvail={wholeAvail}
          teacher={teacherModal}
          removeDeletedTeacher={removeDeletedTeacher}
          setOpenTimesheet={setOpenTimesheet}
          getFamilyData={props.getFamilyData}
          setStudentModal2023={props.setStudentModal2023}
        />
      )}
      <AddTeacherModal
        open={addTeacherModal}
        closeModal={closeNewTeacherModal}
        setAddTeacherModal={setAddTeacherModal}
      />
      {openTimesheet && (
        <ViewTimesheet
          setOpenTimesheet={setOpenTimesheet}
          openTimesheet={openTimesheet}
        />
      )}
      <SearchHeader
        title="Teacher Database"
        cta="New Teacher"
        onChangeQuery={(string) => setNameQuery(string)}
        onChangeFilters={(filterState) => setFilterState(filterState)}
        onClickCta={openNewTeacher}
        filters={filters}
        clearAll={true}
      />
      <div className="admin-dashboard-box">
        {!lineView && (
          <div className="admin-teacher-card-wrapper">
            {loadingSVG && <img className="loading-ping" src={loadingping} />}
            {filteredTeachers.map((teacher, index) => (
              <AdminTeacherCard
                key={`${teacher.TeacherID ?? "teacher"}-${teacher.Email ?? index}`}
                id={`teacher-card-${teacher.TeacherID}`}
                teacherStatus={teacher.Status}
                openModal={(teacher) => setTeacherModal(teacher)}
                teacher={teacher}
                timesheets={timesheets}
              />
            ))}
          </div>
        )}
        {lineView && (
          <div className="the-table-wrapper">
            <div className="student-db-btn-wrapper">
              <div className="add-email-btn" onClick={() => copyAttempt()}>
                COPY EMAILS
              </div>
            </div>
            <table className="student-table">
              <thead>
                <tr>
                  <th>
                    <input
                      onClick={(e) => massCheck(e.target.checked)}
                      type="checkbox"
                    />
                  </th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Students</th>
                  <th>School</th>
                  <th>Status</th>
                </tr>
              </thead>
              {teachersToDisplay.length > 0 ? (
                <tbody>
                  {teachersToDisplay.map((teacher) => (
                    <tr key={teacher.TeacherID} className="each-row">
                      <td>
                        <input
                          className={"student-checkbox"}
                          type="checkbox"
                          value={teacher.Email}
                        />
                      </td>
                      <td onClick={() => setTeacherModal(teacher)}>
                        {teacher.Name}
                      </td>
                      <td onClick={() => setTeacherModal(teacher)}>
                        {teacher.Email}
                      </td>
                      <td onClick={() => setTeacherModal(teacher)}>
                        {teacher.PhoneNumber}
                      </td>
                      <td onClick={() => setTeacherModal(teacher)}>
                        {teacher.newStudentList.length}
                      </td>
                      <td onClick={() => setTeacherModal(teacher)}>
                        {teacher.School}
                      </td>
                      <td onClick={() => setTeacherModal(teacher)}>
                        {teacher.newStudentList.length > 0
                          ? "Active"
                          : "Waiting"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody>
                  <div className="admin-tasks-loading-text">
                    Getting teachers...
                  </div>
                </tbody>
              )}
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
